import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

export default function keysToCamelCase(obj) {
    return mapKeys(obj, (value, key) => camelCase(key));
}
